import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function LogoutButton() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <button onClick={handleLogout} className="bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-bold">
      Logout
    </button>
  );
}
